<div class="w-100" data-test-id="scan-custom-browser-flags">
  <div [formGroup]="form">
    <app-common-checkbox data-test-id="modify-browser-flags-checkbox" [formControl]="modifyBrowserFlags">
      <span class="checkbox-label">{{ 'modify_browser_flags' | translate }}</span>
    </app-common-checkbox>
    @if (modifyBrowserFlags?.value) {
      <div class="margin-left-lg">
        <div class="font-weight-500 mb-2">{{ 'required_browser_flags' | translate }}</div>
        <ul class="d-flex flex-column gap-2 list-unstyled">
          @for (flag of requiredFlagsArray; track flag) {
            <li class="d-flex align-items-center font-size-s">
              <span>{{ flag }} ({{ 'read_only' | translate }})</span>
            </li>
          }
        </ul>
      </div>
      @if (browserFlags?.value?.length) {
        <div class="margin-left-lg">
          <ul class="d-flex flex-column gap-3 list-unstyled">
            @for (flag of browserFlags?.value; track flag) {
              <li class="d-flex align-items-center font-size-s font-weight-500">
                <span class="me-3">{{ flag }}</span>
                <button
                  class="remove-flag-button ds-btn-micro-action ds-btn eap-red-error"
                  type="button"
                  [attr.aria-label]="'remove_browser_flag_aria_label' | translate: flag"
                  (click)="removeBrowserFlag(flag)"
                >
                  <ds-icon class="me-1" [icon]="Icons.CircleMinus"></ds-icon>
                  {{ 'remove_browser_flag' | translate }}
                </button>
              </li>
            }
          </ul>
        </div>
      }
    }
  </div>
  @if (modifyBrowserFlags?.value) {
    <div [formGroup]="newBrowserFlagForm" class="margin-left-lg">
      <div class="row gx-2">
        <div class="col-8 col-lg-6">
          <app-common-input
            data-test-id="add-browser-flag-input"
            [form]="newBrowserFlagForm"
            [context]="{ label: 'add_browser_flag', field: newBrowserFlagControlName }"
            [formValidationRequest$]="browserFlagsValidationRequest$"
            (input)="onNewBrowserFlagInput($event.target.value)"
          />
        </div>
        <div class="col-4 col-lg-3">
          <button
            ds-button
            class="add-browser-flag-button"
            data-test-id="add-browser-flag-button"
            [variant]="DsButtonVariants.primary"
            type="submit"
            (click)="addNewBrowserFlag()"
          >
            {{ 'add_browser_flag_button' | translate }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
